import { render } from "./ContactHeroComponent.vue?vue&type=template&id=53b8f81c"
import script from "./ContactHeroComponent.vue?vue&type=script&lang=js"
export * from "./ContactHeroComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__